import colors from 'vuetify/lib/util/colors'

let defaultTheme = {
  name: 'Default',
  dark: false,

  colors:{
    'overlay' : '#463529',

    'background': '#0D0B0A',
    'on-background': '#F2ECE4',

    'surface': '#1F1A17',
    'on-surface': '#ffdba4',
    
    'primary': '#F0720E',
    'accent': '#FCE97F',
    'secondary': '#6a7e87',
    'error': '#A8110B',
    'info': '#ba56ce',
    'success': '#0ba825',
    'warning': '#df4f16',
    'light': '#efddda',
  }
}

export default defaultTheme